import React from "react";
import { Form, Input, Button, Space, Table, Breadcrumb } from "antd";
import type { TableColumnsType } from "antd";
import { HomeOutlined } from "@ant-design/icons";
import "./list_mechanic_work_order_allocate.css";
import { RiResetLeftFill } from "react-icons/ri";

const ListMechanicWorkOrderAllocate: React.FC = () => {
    const [form] = Form.useForm();
    const Resetbtn = RiResetLeftFill as React.ComponentType<any>;
    const columns: TableColumnsType<any> =[
        { title: "Technician", dataIndex: "technician", key: "technician" },
        { title: "Service Start Time", key: "service_start_time_col", width: 150 },
        { title: "Available Start Time", dataIndex: "availableStartTime", key: "availableStartTime" },
        { title: "Available End Time", dataIndex: "availableEndTime", key: "availableEndTime" },
        { title: "Available Hours", dataIndex: "availableHours", key: "availableHours" },
        { title: "Available Status", dataIndex: "availableStatus", key: "availableStatus" },
    ];

    const transformStyle = { transform: "scale(0.80)", transformOrigin: "top left", width: "125%" };


    return (
        <div id="i4e7" style={transformStyle}>
            <div className="gjs-grid-row" id="iy75">
                <div className="gjs-grid-column" id="iwrj">
                    <Breadcrumb
                        items={[
                            {
                                title: <HomeOutlined />,
                            },
                            {
                                href: "#/dashboard/allocate_work_order",
                                title: (
                                    <>
                                        <span>Allocate Work Order</span>
                                    </>
                                ),
                            },
                            {
                                title: "List Mechanic Work Order",
                            },
                        ]}
                    />
                </div>
            </div>
            <div className="gjs-grid-row" id="iottg">
                <div className="gjs-grid-column" id="ii4z">
                    <Button className="gr-button">
                        <Resetbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        Reset
                    </Button>
                </div>
            </div>
            <Form
                form={form}
                layout="horizontal"
                style={{ maxWidth: '100%' }}
                labelCol={{ style: { width: "150px", textAlign: "left" } }}
                wrapperCol={{ style: { width: "290px" } }}
                className="custom-info-purchase-request">
                <div className="gjs-grid-row" id="iottg">
                    <div className="gjs-grid-column" id="ii4z">
                        <Form
                            form={form}
                            layout="horizontal"
                            style={{ maxWidth: 400 }}
                            labelCol={{ style: { width: "150px", textAlign: "left" } }}
                            wrapperCol={{ style: { width: "290px" } }}
                            className="custom-info-purchase-request">
                            <Form.Item label="Status" name="status" style={{ marginBottom: "5px" }}>
                                <Input placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item label="Operation Number" name="operation_no" style={{ marginBottom: "5px" }}>
                                <Input placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item label="Operation Name" name="operation_name" style={{ marginBottom: "5px" }}>
                                <Input placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item label="Work Order No" name="work_order_no" style={{ marginBottom: "5px" }}>
                                <Input placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item label="FRT" name="frt" style={{ marginBottom: "5px" }}>
                                <Input placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item label="Allocated FRT" name="allocate_frt" style={{ marginBottom: "5px" }}>
                                <Input placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item label="Service Date" name="service_date" style={{ marginBottom: "5px" }}>
                                <Input placeholder="" readOnly />
                            </Form.Item>
                            <Form.Item label="Current Time" name="current_time" style={{ marginBottom: "5px" }}>
                                <Input placeholder="" readOnly />
                            </Form.Item>
                        </Form>
                    </div>
                </div>
                 <div className="gjs-grid-row" id="ik56c">
                    <div className="gjs-grid-column" id="igm42">
                        <Table columns={columns} dataSource={[]} pagination={{ pageSize: 5 }} />
                    </div>
                </div>
            </Form>
        </div>
    );
};
export default ListMechanicWorkOrderAllocate;